import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'isrc'})
export class IsrcPipe implements PipeTransform {

  transform(value: string): string {
    return value ? value.trim().toLowerCase().replace(/-/g, '') : '';
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/isrc.pipe.ts